import { useEffect } from 'react';
import { useStoreSelect } from '../../../hooks';
import useStorePermissions from '../../../hooks/useStorePermissions';
import { usePermissions } from '../../Permissions';
import SimpleSelect, { SimpleSelectOption, SimpleSelectProps } from '../SimpleSelect';

export interface StoreSimpleSelectProps extends Omit<SimpleSelectProps, 'options'> {
  countryCode: string;
  emptySelection?: string;
}

const StoreSimpleSelect = ({
  disabled,
  countryCode,
  emptySelection,
  onChange,
  ...others
}: StoreSimpleSelectProps) => {
  const { loading, disabled: disabledSelect } = useStoreSelect(countryCode, emptySelection);
  const { resourcePermissions } = usePermissions();
  const isDisabled = disabled || disabledSelect;

  const options = useStorePermissions(resourcePermissions, countryCode) as SimpleSelectOption[];

  useEffect(() => {
    if (options.length === 1) onChange(options[0].id);
  }, [onChange, options]);

  return (
    <SimpleSelect
      {...others}
      options={options}
      disabled={isDisabled}
      loading={loading}
      onChange={onChange}
    />
  );
};

export default StoreSimpleSelect;
